const status = [
  { value: "open", name: "help_center.status.open", icon: "bx:folder-open" },
  {
    value: "resolved",
    name: "help_center.status.resolved",
    icon: "el:ok-circle",
  },
  {
    value: "closed",
    name: "help_center.status.closed",
    icon: "ic:baseline-done-all",
  },
  {
    value: "archived",
    name: "help_center.status.archived",
    icon: "bx:archive",
  },
  {
    value: "deleted",
    name: "help_center.status.deleted",
    icon: "fluent:delete-12-regular",
  },
  {
    value: "unverified",
    name: "help_center.status.unverified",
    icon: "octicon:unverified-24",
  },
  {
    value: "request_approval",
    name: "help_center.status.request_approval",
    icon: "fluent:approvals-app-24-filled",
  },
  {
    value: "in_progress",
    name: "help_center.status.in_progress",
    icon: "mdi:progress-helper",
  },
  {
    value: "responded",
    name: "help_center.status.responded",
    icon: "mdi:calendar-remove-outline",
  },
];

export default status;
